export default __webpack_public_path__ + "static/media/Inconsolata-Regular.b29b3f64.eot";